import React from "react";

function DTOLoans() {
  return <></>;
}
export default DTOLoans;
